import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';

// ===== Psychotherapeutische Beratungsstelle für Studierende =====

export const pbsRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::pbs',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new PBSStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(PBSStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => PBSStammdaten,
};

export enum PBSFachbereichEnum {
  PBS_FB1 = 'PBS_FB1',
  PBS_FB2 = 'PBS_FB2',
  PBS_FB3 = 'PBS_FB3',
  PBS_FB4 = 'PBS_FB4',
  PBS_FB5 = 'PBS_FB5',
  PBS_FB6 = 'PBS_FB6',
  PBS_FB7 = 'PBS_FB7',
  PBS_FB8 = 'PBS_FB8',
  PBS_FB9 = 'PBS_FB9',
  PBS_FB10 = 'PBS_FB10',
  PBS_FB11 = 'PBS_FB11',
  PBS_FB12 = 'PBS_FB12',
  PBS_FB13 = 'PBS_FB13',
  PBS_FB14 = 'PBS_FB14',
  PBS_FB15 = 'PBS_FB15',
  PBS_FB16 = 'PBS_FB16',
}
registerEnum({ enum: PBSFachbereichEnum, name: 'PBSFachbereichEnum' });

@Entity()
export class PBSStammdaten extends UserStammdaten {
  static override _class = 'PBSStammdaten';

  override getTranslationNamespace() {
    return 'pbs';
  }

  @Field(type => Int)
  age: Maybe<number>;

  @Field(type => PBSFachbereichEnum)
  fachbereich: Maybe<PBSFachbereichEnum>;

  @Field(type => String)
  studienfach: Maybe<string>;

  @Field(type => Boolean, { default: value => value ?? false })
  ichMchteberDenNewsletterberAngeboteInformiertWerden!: boolean;
}
